// Single Page Code
// Podcast Player Plyr
// GSAP ScrollTrigger for Sticky Image
jQuery(window).on('load', function () {
    // check if single page
    if (!jQuery('.mad-podcast-single').length) {
        return;
    }

    $dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
        gsap.registerPlugin(ScrollTrigger);

        function makeImageSticky() {
            const $image = jQuery("#podcast-single-image");
            const $parent = $image.parent(".mad-podcast-single__image");
            const $container = $image.closest(".brz-wrapper").parent();

            var offset = 0;
            jQuery.each(['#wpadminbar', '.mad-navbar__section'], function (index, element) {
                if (jQuery(element).length) {
                    offset += jQuery(element).outerHeight();
                }
            });

            console.log({offset, $container, height: $container.height()})

            ScrollTrigger.matchMedia({
                // Desktop
                "(min-width: 992px)": function () {
                    console.log({
                        start: "top top+=" + offset,
                        end: "bottom" + " top+=" + (offset + $container.height()),
                    })

                    gsap.to($container, {
                        scrollTrigger: {
                            trigger: ".mad-podcast-single",
                            start: "top top+=" + offset,
                            end: "bottom+=" + offset + " bottom",
                            pin: $parent[0],
                            pinSpacing: true,
                            scrub: 1,
                            markers: false // Markers for Debugging
                        }
                    });
                },
                // Tablet and Mobile
                "(max-width: 991px)": function () {
                    // No ScrollTrigger for tablet and mobile
                }
            });
        }

        // Initialize the sticky image animation
        makeImageSticky();
    });
});


// Documentation: https://www.notion.so/maddesignmedia/Wordpress-Theme-c9a401398bae4ec8ad06ee763dae46b4#176e2705158180649a6adb153ac5c907

jQuery(document).ready(function($) {

    // Check if Page has a valid Player Button
    if (!jQuery('.mad-podcast-btn-start-plyr').length > 0) {
        return;
    }

    const AudioPlayer = {
        isFullPlayer: false,
        currentlyPlayingID: null,
        init: function(options = { autoInit: false, isFullPlayer: false }) {
            this.isFullPlayer = options.isFullPlayer,
            this.setupPlayer();
            this.attachButtonListener();
            this.attachCloseListener();
            this.setupPlyrEvents();

            if (options.autoInit) {
                this.autoInitialize();
            }
        },

        setupPlayer: function() {
            if (!jQuery('#mad-audio-player').length > 0) {
                // Append a minimal global player if not present
                jQuery('body').append(`
                    <div id="mad-audio-player" class="mad-audio-player__container mad-audio-player__container--default plyr__audio-embed--default mad-audio-player__hidden">
                        <div class="mad-audio-player">
                            <button id="close-audio-player" class="mad-audio-player__close-button">&times;</button>
                            <div class="mad-audio-player__audio-info">
                                <img src="" alt="Podcast Image" class="mad-audio-player__image" loading="lazy">
                                <div class="mad-audio-player__audio-details">
                                    <h5 class="mad-audio-player__audio-title"></h5>
                                    <p class="mad-audio-player__audio-artist"></p>
                                </div>
                            </div>
                            <div class="plyr__audio-player">
                                <audio id="player" controls>
                                    <source src="" type="audio/mp3" />
                                </audio>
                            </div>
                        </div>
                    </div>
                `);
            }
            this.playerElement = document.querySelector('#player');
            this.plyrInstance = new Plyr('#player', {iconUrl: window.madPlyrIconUrl, storage: { enabled: false }});
        },

        attachButtonListener: function() {
            jQuery('.mad-podcast-btn-start-plyr').on('click', function(e) {
                e.preventDefault();
                const podcastId = this.getAttribute('data-id');
                AudioPlayer.handlePlay(podcastId);
            });
        },

        // Fill the audio player details with given podcast data
        fillPlayerData: function(podcast) {
            const { audio_url, title, creator, categories, date, image_url, image_small_url } = podcast;
            const image = this.isFullPlayer ? image_url : image_small_url;

            const sourceElement = this.playerElement.querySelector('source');
            sourceElement.src = audio_url;
            this.playerElement.load();

            const titleEl = document.querySelector('.mad-audio-player__audio-title');
            if (titleEl) titleEl.textContent = title;
        
            const artistEl = document.querySelector('.mad-audio-player__audio-artist');
            if (artistEl) artistEl.textContent = creator;
        
            const categoriesEl = document.querySelector('.mad-audio-player__audio-categories');
            if (categoriesEl) categoriesEl.textContent = categories.join(', ') + " • " + date;
        
            const imageEl = document.querySelector('.mad-audio-player__image');
            if (imageEl) imageEl.setAttribute('src', image);
        },

        // Called when a play button is clicked
        handlePlay: function(podcastId) {
            const currentPodcast = madPodcastData.find(p => p.id == podcastId);

            // Pause Podcast if already playing
            if (this.currentlyPlayingID === podcastId) {
                if (this.plyrInstance.playing) {
                    this.plyrInstance.pause();
                    this.updateButtonState(podcastId, false);
                    return;
                }
            }
            this.updateButtonState(this.currentlyPlayingID, false);

            this.currentlyPlayingID = podcastId;
            this.removePlayingAnimation();
            if (currentPodcast) {
                this.fillPlayerData(currentPodcast);
                jQuery('#mad-audio-player').removeClass('mad-audio-player__hidden').addClass('mad-audio-player__visible');
                this.addPlayingAnimation(podcastId);
                this.updateButtonState(podcastId, true);
                this.plyrInstance.play();

            } else {
                console.error('Podcast not found for id:', podcastId);
            }
        },

        updateButtonState: function(podcastId, isPlaying) {
            if (podcastId === null) return;
            const $button = jQuery(`.mad-podcast-btn-start-plyr[data-id="${podcastId}"]`);
            const iconClass = isPlaying ? 'dashicons dashicons-controls-pause' : 'dashicons dashicons-controls-play';
            
            let html, ariaLabel;
            if (this.isFullPlayer) {
                const text = isPlaying ? 'Pause' : 'Anhören';
                html = `
                    <span class="mad-podcasts__play-button__text">${text}</span>
                    <span class="${iconClass}"></span>
                `;
                const currentLabel = $button.attr('aria-label').replace(/(Play|Pause)/, '').trim();
                ariaLabel = isPlaying ? `Pause ${currentLabel}` : `Play ${currentLabel}`;
            } else {
                html = `<span class="${iconClass}"></span>`;
                ariaLabel = isPlaying ? 'Pause' : 'Play';
            }
        
            $button.html(html);
            $button.attr('aria-label', ariaLabel);
        },

        // Auto initialize the player using a default podcast
        autoInitialize: function() {
            if (madPodcastData && madPodcastData.length > 0) {
                const defaultPodcast = madPodcastData[0];
                this.fillPlayerData(defaultPodcast);
                this.currentlyPlayingID = defaultPodcast.id;
            }
        },

        // Attach close button listener
        attachCloseListener: function() {
            jQuery('#close-audio-player').on('click', function() {
                jQuery('#mad-audio-player').removeClass('mad-audio-player__visible').addClass('mad-audio-player__hidden');
                if (AudioPlayer.plyrInstance) {
                    AudioPlayer.plyrInstance.stop();
                }
                AudioPlayer.removePlayingAnimation();
            });
        },

        // Register Plyr events (for example, to remove animations on pause)
        setupPlyrEvents: function() {
            this.plyrInstance.on('pause', () => {
                this.updateButtonState(this.currentlyPlayingID, false);
                this.removePlayingAnimation();
            });
            this.plyrInstance.on('play', () => {
                this.updateButtonState(this.currentlyPlayingID, true);
                this.addPlayingAnimation(this.currentlyPlayingID);
            });
        },

        // Add an animation overlay to the podcast image container
        addPlayingAnimation: function(podcastId) {
            const imageId = `#mad-podcasts__image-${podcastId}`;
            const $imageContainer = jQuery(imageId).parent();
            $imageContainer.find('.mad-podcast-playing-animation').remove();
            $imageContainer.append(`
                <div class="mad-podcast-playing-animation">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                </div>
            `);
        },

        // Remove any playing animation overlay
        removePlayingAnimation: function() {
            jQuery('.mad-podcast-playing-animation').remove();
        }
    };

    // Initialize the player.
    $dependencyManager.addDependencyCallback('plyr', () => {
        if (jQuery('#mad-audio-player').length > 0) {
            jQuery(window).on('load', function() {
                AudioPlayer.init({ autoInit: true, isFullPlayer: true });
            });
        } else {
            AudioPlayer.init({ autoInit: false });
        }
    });    
});